<script >
import DashboardNew from "@/components/menu/DashboardNew.vue";
import {mapState} from "vuex";
import MessagingRequest from "@/model/request/MessagingRequest";
import store from "@/store/store";


export default {
  name:'InfluencerPimChat',
  components: {DashboardNew},
  data(){
    return{
      model:MessagingRequest.prototype.create(),
      groupModel:MessagingRequest.prototype.readByGroupId(),
      dropdown:false,
      current:false,
      messageOne:true,
      messageTwo:false,
      messageThree:false,
      selectedUser: "",
      selectedUserId:"",
      search: "",
      intervals: [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 },
        { label: 'second', seconds: 1 }
      ],
    }
  },
  methods:{
    timeSince(date) {
      let newdate = new Date(date)
      const seconds = Math.floor((Date.now() - newdate.getTime()) / 1000);
      const interval = this.intervals.find(i => i.seconds < seconds);
      const count = Math.floor(seconds / interval.seconds);
      return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
    },
    returnInitials(name){
      return name.split(' ')[0].charAt(0).toUpperCase() + name.split(' ')[1].charAt(0).toUpperCase()
    },
    activateMessageOne(id, user, userId){
      this.selectedUserId= userId
      this.selectedUser = user
      this.groupModel.messageGroupId = id;
      store.dispatch("message/readByGroupId", this.groupModel)
      this.messageOne = true
      this.messageTwo = false
      this.messageThree = false
      this.current=true
    },
    createMessage(){
      this.model.messageTo = this.selectedInfluencer.customerId || this.selectedUserId;
      this.model.messageGroupId = this.messages.data[0].messageGroupId
      store.dispatch("message/create", this.model).then((res) => {
        store.dispatch(
          "message/readByCustomerId",
          this.auth.userInfo.customerId
        );
        if (res.responseCode === "00"){
          this.model.messageBody = ""
        }
      })


    },
    toggleDropdown(){
      this.dropdown = true
    },
    activateMessageTwo(){
      this.messageOne = false
      this.messageTwo = true
      this.messageThree = false
    },
    activateMessageThree(){
      this.messageOne = false
      this.messageTwo = false
      this.messageThree = true
    }
  },
  computed:{
    ...mapState({
      message:(state)=>state.message.message,
      messages:(state)=>state.message.messages,
      loading:(state)=>state.message.loading,
      selectedInfluencer: (state) => state.pimCampaign.selectedInfluencer,
      selectedPackage: (state) => state.pimCampaign.selectedPackage,
      auth: (state) => state.auth
    }),
  },
  mounted(){
    if (this.message.data.length > 0){
      this.selectedUser = this.message.data[0].messageInfluencerName;
      this.groupModel.messageGroupId = this.message.data[0].messageGroupId;
      store.dispatch("message/readByGroupId", this.groupModel)
    }
  },
  watch: {
    message(){
      if (this.message.data.length > 0){
        this.selectedUser = this.message.data[0].messageInfluencerName;
        this.groupModel.messageGroupId = this.message.data[0].messageGroupId;
        store.dispatch("message/readByGroupId", this.groupModel)
      }
    }
  }

}
</script>

<template>
<div>
  <dashboard-new/>
  <div class="section" style="height: 100vh">
    <div class="dashboard-wrapper">
      <div class="chat-box-wrapper">
        <div class="chat-frame-grid">
          <div id="w-node-_7f2f5710-63f9-76ea-cb62-6e5960164aa9-e7592d84" class="chat-side-bar">
            <div class="chat-tab-list">
              <div class="chat-tab is-vertical">
                <div class="section-header2_form-block w-form">
                  <form id="wf-form-Filter-1" name="wf-form-Filter-1" data-name="Filter 1" method="get" fs-cmsfilter-element="filters" class="section-header2_form" data-wf-page-id="64cb40cb8700d259e7592d84" data-wf-element-id="e474e91a-4f4a-efc2-dbda-92e8ef385148">
                    <div class="section-header2_search"><input type="text" class="form-input is-search-input w-input" v-model="search" maxlength="256" name="field-2" fs-cmsfilter-field="IDENTIFIER" data-name="Field 2" placeholder="Search" fs-cmsfilter-debounce="200" id="field-2">
                      <div class="search-icon w-embed"><svg width="100%" height="100%" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z" fill="currentColor"></path>
                      </svg></div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="chat-list-group">
                <a href="#" class="chat-tab is-active w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">
                  <div class="chat-text">
                    <div class="chat-preview">
                      <div class="contact-name">Tanyer Assler</div>
                      <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>
                    </div>
                    <div class="last-message-time">
                      <div class="online-status"></div>
                      <div>5mins</div>
                    </div>
                  </div>
                </a>
                <a href="#" class="chat-tab w-inline-block"></a>
              </div>
            </div>
            <div class="chat-support"><img src="../../assets/images/whatsapp_2.svg" loading="lazy" alt="">
              <div class="chat-support-text">
                <div>Support - 0901234567890</div>
                <div class="text-block-42">Contact us for immediate assistance</div>
              </div>
            </div>
          </div>
          <div class="chat-screen">
            <div class="chat-header"></div>
            <div class="chat-header">
              <div class="chat-wrapper">
                <div class="chat-screen-header">
                  <div class="chat-contact">
                    <div class="chat-profile-image">
                      <div v-if="selectedUser">{{ selectedInfluencer.customerName ? returnInitials(selectedInfluencer.customerName) : returnInitials(selectedUser) }}</div>
                    </div>
                    <div class="chat-profile-name">{{ selectedInfluencer.customerName ? selectedInfluencer.customerName : selectedUser}}</div>
                  </div>
                  <a @click="dropdown=true" class="chat-header-cta-group" :class="{'more-message':dropdown===true}">
                    <a @click="toggleDropdown" data-hover="false" data-delay="200" data-w-id="a2a82930-7979-0345-44fc-844cb54e761f" class="dropdown1_component w-dropdown" :class="{'more-message':dropdown===true}">
                      <div class="dropdown1_toggle w-dropdown-toggle" :class="{'w--open':dropdown===true}" id="w-dropdown-toggle-2" aria-controls="w-dropdown-list-2" aria-haspopup="menu" aria-expanded="true" role="button" tabindex="0"><img src="../../assets/images/more-horizontal.svg" loading="lazy" width="24" alt=""></div>
                      <nav style="transform: translate3d(0px, 0rem, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); opacity: 0; transform-style: preserve-3d;" class="dropdown1_dropdown-list-3 w-dropdown-list" :class="{'w--open show':dropdown===true}" id="w-dropdown-list-2" aria-labelledby="w-dropdown-toggle-2">
                        <a href="#" class="dropdown1_dropdown-link-3 w-dropdown-link" tabindex="0">Mark as completed</a>
                        <a href="#" data-w-id="5002deb7-5c8a-774c-7610-305e555f2abb" class="dropdown1_dropdown-link-3 w-dropdown-link" tabindex="0">Create Custom order</a>
                        <a href="#" data-w-id="a2a82930-7979-0345-44fc-844cb54e7627" class="dropdown1_dropdown-link-3 w-dropdown-link" tabindex="0">Raise Dispute</a>
                        <a href="#" class="close-chat w-dropdown-link" tabindex="0">Close Chat</a>
                      </nav>
                    </a>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="chat-wrapper">
                <div class="chat-message-list">
                  <div class="chat-message-box">
                    <div class="chat-message-image">TA</div>
                    <div class="chat-message">
                      <div class="chat-message-title">
                        <div class="chat-message-contact-name">Tanyer Assler</div>
                        <div class="chat-message-date">July 27, 2023</div>
                      </div>
                      <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>
                    </div>
                  </div>
                  <div class="chat-message-box">
                    <div class="chat-message-image">TA</div>
                    <div class="chat-message">
                      <div class="chat-message-title">
                        <div class="chat-message-contact-name">Tanyer Assler</div>
                        <div class="chat-message-date">July 27, 2023</div>
                      </div>
                      <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>
                    </div>
                  </div>
                  <div class="chat-message-box">
                    <div class="chat-message-image">TA</div>
                    <div class="chat-message">
                      <div class="chat-message-title">
                        <div class="chat-message-contact-name">Tanyer Assler</div>
                        <div class="chat-message-date">July 27, 2023</div>
                      </div>
                      <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat">
          <div id="w-node-_6dda2c98-9a8b-2343-e8b3-caecf3a361c8-e7592d84" class="chat-grid">
            <div class="chat-tab is-vertical">
              <div class="section-header2_form-block w-form">
                <form id="wf-form-Filter-1" name="wf-form-Filter-1" data-name="Filter 1" method="get" fs-cmsfilter-element="filters" class="section-header2_form" data-wf-page-id="64cb40cb8700d259e7592d84" data-wf-element-id="5e7779df-969e-44d7-11fb-555f9a53b6ab">
                  <div class="section-header2_search"><input type="text" class="form-input is-search-input w-input" maxlength="256" name="field-2" fs-cmsfilter-field="IDENTIFIER" data-name="Field 2" placeholder="Search" fs-cmsfilter-debounce="200" id="field-2">
                    <div class="search-icon w-embed"><svg width="100%" height="100%" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z" fill="currentColor"></path>
                    </svg></div>
                  </div>
                </form>
              </div>
            </div>
            <div id="w-node-_8be726aa-1ea9-2fda-35b6-0b143d243602-e7592d84" class="chat-head">
              <div class="chat-wrapper">
                <div class="chat-screen-header">
                  <div class="chat-contact">
                    <div class="chat-profile-image">
                      <div v-if="selectedUser">{{ selectedInfluencer.customerName ? returnInitials(selectedInfluencer.customerName) : returnInitials(selectedUser) }}</div>
                    </div>
                    <div class="chat-profile-name">{{ selectedInfluencer.customerName ? selectedInfluencer.customerName : selectedUser}}</div>
                  </div>
                  <div class="chat-header-cta-group">
                    <a href="#" class="chat-header-cta w-inline-block"><img src="../../assets/images/more-horizontal.svg" loading="lazy" width="24" alt=""></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="w-node-_1d48776b-ce3b-f171-facb-34678d84ab60-e7592d84" data-current="Tab 2" data-easing="ease" data-duration-in="300" data-duration-out="100" class="chat-grid w-tabs">
            <div id="w-node-_1d48776b-ce3b-f171-facb-34678d84ab61-e7592d84" class="chat-list-group w-tab-menu" >
              <a v-for="(messaged,index) in message.data" :key="index"  @click="activateMessageOne(messaged.messageGroupId, messaged.messageInfluencerName)" data-w-tab="Tab 1" class="chat-tab w-inline-block w-tab-link" :class="{'w--current':messaged.messageParticipantName===selectedUser }"><img alt="" loading="lazy" :src="messaged.messageInfluencerPicture" class="recipient-image">
                <div class="chat-text">
                  <div class="chat-preview">
                    <div class="contact-name">{{messaged.messageInfluencerName}}</div>
                    <div class="chat-preview-text" style="text-transform: capitalize">{{ messaged.messageBody }}</div>
                  </div>
                  <div class="last-message-time" >
                    <div class="online-status"></div>
                    <div>{{timeSince(messaged.messageCreatedAt)}}</div>
                  </div>
                </div>
              </a>
<!--              <a @click="activateMessageTwo" data-w-tab="Tab 2" class="chat-tab w-inline-block w-tab-link" :class="{'w&#45;&#45;current':messageTwo===true}"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">-->
<!--                <div class="chat-text">-->
<!--                  <div class="chat-preview">-->
<!--                    <div class="contact-name">Tanyer Assler</div>-->
<!--                    <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>-->
<!--                  </div>-->
<!--                  <div class="last-message-time">-->
<!--                    <div class="online-status"></div>-->
<!--                    <div>5mins</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </a>-->
<!--              <a @click="activateMessageThree" data-w-tab="Tab 3" class="chat-tab w-inline-block w-tab-link" :class="{'w&#45;&#45;current':messageThree===true}"><img alt="" loading="lazy" src="../../assets/images/DBS_Amira_web_0037.jpg" class="recipient-image">-->
<!--                <div class="chat-text">-->
<!--                  <div class="chat-preview">-->
<!--                    <div class="contact-name">Tanyer Assler</div>-->
<!--                    <div class="chat-preview-text">Hello Seun, Thanks for reac...</div>-->
<!--                  </div>-->
<!--                  <div class="last-message-time">-->
<!--                    <div class="online-status"></div>-->
<!--                    <div>5mins</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </a>-->
            </div>
            <div class="w-tab-content" v-if="selectedInfluencer.customerName"></div>
            <div class="w-tab-content" v-if="messages.data.length>0">
              <div data-w-tab="Tab 1" class="w-tab-pane" :class="{'w--tab-active':messageOne===true}" >
                <div class="chat-messages">
                  <div class="chat-wrapper">
                    <div class="chat-message-list">
                      <div v-for="(messaged,index) in messages.data" :key="index" class="chat-message-box">
                        <div class="chat-message-image" v-if="messaged.messageSenderName">{{ returnInitials(messaged.messageSenderName) }}</div>
                        <div class="chat-message">
                          <div class="chat-message-title">
                            <div class="chat-message-contact-name">{{messaged.messageSenderName}}</div>
                            <div class="chat-message-date"> {{new Date(messaged.messageCreatedAt).getDate()}} {{new Date(messaged.messageCreatedAt).toLocaleString('en-us',{month:'short'})}} {{new Date(messaged.messageCreatedAt).getFullYear()}}</div>
                          </div>
                          <p class="chat-message-text">{{messaged.messageBody}}</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
<!--              <div data-w-tab="Tab 2" class="w-tab-pane" :class="{'w&#45;&#45;tab-active':messageTwo===true}">-->
<!--                <div class="chat-messages">-->
<!--                  <div class="chat-wrapper">-->
<!--                    <div class="chat-message-list">-->
<!--                      <div class="chat-message-box">-->
<!--                        <div class="chat-message-image">TA</div>-->
<!--                        <div class="chat-message">-->
<!--                          <div class="chat-message-title">-->
<!--                            <div class="chat-message-contact-name">Tanyer Assler</div>-->
<!--                            <div class="chat-message-date">July 27, 2023</div>-->
<!--                          </div>-->
<!--                          <p class="chat-message-text">Affiliate marketing is an excellent way to earn passive income. this type of website doesn&#x27;t require any extra maintenance or technical knowledge to run.Every product will be linked with your unique affiliate ID so that you will earn commissions on every sale.</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="chat-message-box">-->
<!--                        <div class="chat-message-image">TA</div>-->
<!--                        <div class="chat-message">-->
<!--                          <div class="chat-message-title">-->
<!--                            <div class="chat-message-contact-name">Tanyer Assler</div>-->
<!--                            <div class="chat-message-date">July 27, 2023</div>-->
<!--                          </div>-->
<!--                          <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="chat-message-box">-->
<!--                        <div class="chat-message-image">TA</div>-->
<!--                        <div class="chat-message">-->
<!--                          <div class="chat-message-title">-->
<!--                            <div class="chat-message-contact-name">Tanyer Assler</div>-->
<!--                            <div class="chat-message-date">July 27, 2023</div>-->
<!--                          </div>-->
<!--                          <p class="chat-message-text">Affiliate marketing is an excellent way to earn passive income. this type of website doesn&#x27;t require any extra maintenance or technical knowledge to run.Every product will be linked with your unique affiliate ID so that you will earn commissions on every sale.</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-w-tab="Tab 3" class="w-tab-pane" :class="{'w&#45;&#45;tab-active':messageThree===true}">-->
<!--                <div class="chat-messages">-->
<!--                  <div class="chat-wrapper">-->
<!--                    <div class="chat-message-list">-->
<!--                      <div class="chat-message-box">-->
<!--                        <div class="chat-message-image">TA</div>-->
<!--                        <div class="chat-message">-->
<!--                          <div class="chat-message-title">-->
<!--                            <div class="chat-message-contact-name">Tanyer Assler</div>-->
<!--                            <div class="chat-message-date">July 27, 2023</div>-->
<!--                          </div>-->
<!--                          <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="chat-message-box">-->
<!--                        <div class="chat-message-image">TA</div>-->
<!--                        <div class="chat-message">-->
<!--                          <div class="chat-message-title">-->
<!--                            <div class="chat-message-contact-name">Tanyer Assler</div>-->
<!--                            <div class="chat-message-date">July 27, 2023</div>-->
<!--                          </div>-->
<!--                          <p class="chat-message-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
            <div v-else-if="loading" style="display: flex;align-items: center;justify-content: center">Loading Messages...</div>
            <div v-else style="display: flex; align-items: center; justify-content: center">No messages</div>
          </div>
          <div id="w-node-dc2ebea3-403b-59ea-d868-b33ac3668955-e7592d84" class="chat-grid">
            <div class="chat-support alt"><img src="../../assets/images/whatsapp_2.svg" loading="lazy" alt="">
              <div class="chat-support-text">
                <div class="text-block-43">Support - 0901234567890</div>
                <div class="text-block-42">Contact us for immediate assistance</div>
              </div>
            </div>
            <div id="w-node-_162b2b24-5d48-4190-8573-a34d1a135908-e7592d84" class="div-block-251">
              <div class="section-header2_form-block w-form">
                <form id="wf-form-Filter-1" name="wf-form-Filter-1" data-name="Filter 1" method="get" fs-cmsfilter-element="filters" class="section-header2_form" data-wf-page-id="64cb40cb8700d259e7592d84" data-wf-element-id="18f1b248-89c6-422f-179a-1c2e326da788">
                  <div class="section-type-message">  <input type="text" v-model="model.messageBody" class="form-input is-message-input w-input" maxlength="256" name="field-2" fs-cmsfilter-field="IDENTIFIER" data-name="Field 2" placeholder="Type a message here..." fs-cmsfilter-debounce="200" id="field-2">
                    <div class="search-icon w-embed"><svg width="100%" height="100%" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z" fill="currentColor"></path>
                    </svg></div>
                    <a @click="createMessage" class="link-block-29 w-inline-block"><img src="../../assets/images/send.svg" loading="lazy" alt="" v-if="!loading"><b-spinner v-else small
                                                                                                                                                                            style="color: #fff"/></a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.last-message-time{
  align-self: center;
}
.form-input{
  color: black;
}
.search-icon{
  display: flex;
}
.more-message{
  z-index: 901;
}
.show{

  transform: translate3d(0px, 0rem, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg) !important;
  transform-style: preserve-3d !important;
  display:block !important;
  opacity: 1 !important;
}

</style>